import Vue from "vue";
import {deepInit} from "../utils";

/**
 * @template T
 * @param {T} v
 * @param {(val: T, old: T) => any} [fn]
 * @returns {T}
 */
export function watch(v, fn) {
	return new Vue({
		data: {v: v},
		watch: fn && {v: {deep: true, handler: fn}},
	}).v;
}

let watchLocalMap = {};
/**
 * @template T
 * @param {string} key
 * @param {T} v
 * @returns {T}
 */
export function watchLocal(key, v) {
	if (watchLocalMap[key]) {
		console.error("请不要重复watchLocal同一个key", key);
		return watchLocalMap[key];
	}
	try {
		deepInit(v, JSON.parse(localStorage.getItem(key)));
		if (typeof v.afterLoad === "function") v.afterLoad();
	} catch (error) {}
	return (watchLocalMap[key] = watch(v, function () {
		localStorage.setItem(
			key,
			JSON.stringify(v, (k, v) => (k[0] == "_" ? undefined : v))
		);
	}));
}
